import { render, staticRenderFns } from "./SearchReborn.vue?vue&type=template&id=3cb88db2&scoped=true&"
import script from "./SearchReborn.vue?vue&type=script&lang=ts&"
export * from "./SearchReborn.vue?vue&type=script&lang=ts&"
import style0 from "./SearchReborn.vue?vue&type=style&index=0&id=3cb88db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb88db2",
  null
  
)

export default component.exports